import { PROPERTY_GRID_SUBJECT_PROPERTY, Site, getSiteDisplay } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import { AdjustmentField } from '../../../components/PropertyGrid/fields/AdjustmentField.tsx';
import { LabelField } from '../../../components/PropertyGrid/fields/LabelField.tsx';
import { ReadOnlyField } from '../../../components/PropertyGrid/fields/ReadOnlyField.tsx';
import { getAloftAreaJSONPropertyGridField } from '../../../components/PropertyGrid/fields/utils.tsx';
import { TitleRow } from '../../../components/PropertyGrid/rows/TitleRow.tsx';
import {
  PropertyGridField,
  PropertyGridSectionProps,
} from '../../../components/PropertyGrid/types.ts';
import { useWatch } from 'react-hook-form';

export const AdjustmentsGridSiteExtractionSection = ({
  columnIndex,
  fieldTypes,
  control,
  getValues,
  setValue,
}: PropertyGridSectionProps) => {
  const showLabels = fieldTypes.includes('label');
  const showAdjustments = fieldTypes.includes('adjustment');

  const propertyId = useWatch({
    name: `columns.${columnIndex}.propertyId`,
    control,
  });
  const isSubject = propertyId === PROPERTY_GRID_SUBJECT_PROPERTY;

  let colSpan = 1;
  if (isSubject) {
    const hasArvValue = fieldTypes.includes('readOnlyArvValue');
    const hasAivValue = fieldTypes.includes('readOnlyValue');
    if (hasArvValue && hasAivValue) {
      colSpan = 2;
    } else {
      colSpan = 1;
    }
  }

  const influenceField: PropertyGridField<Site> = {
    fieldName: 'editableData.site',
    label: 'Site Influence',
    toDisplayValue: (site) => getSiteDisplay(site).influence,
  };

  const viewField: PropertyGridField<Site> = {
    fieldName: 'editableData.site',
    label: 'View',
    toDisplayValue: (site) => getSiteDisplay(site).view,
  };

  return (
    <>
      <TitleRow
        columnIndex={columnIndex}
        fieldTypes={fieldTypes}
        title="Site Extraction Adjustments"
        getValues={getValues}
        control={control}
      />
      {showLabels && (
        <LabelField
          columnIndex={columnIndex}
          field={{
            fieldName: 'editableData.site.area',
            label: 'Site Size',
            manualAdjustmentKey: 'site',
          }}
          control={control}
          getValues={getValues}
          setValue={setValue}
        />
      )}
      <ReadOnlyField
        columnIndex={columnIndex}
        field={getAloftAreaJSONPropertyGridField('editableData.site.area', 'Site Size')}
        colSpan={colSpan}
        control={control}
        getValues={getValues}
        setValue={setValue}
      />
      {showAdjustments && (
        <Flex gridColumn={isSubject ? undefined : '2'} gridRow="span 3">
          <AdjustmentField
            columnIndex={columnIndex}
            field={{
              fieldName: 'editableData.site',
              label: 'Site Adjustment',
              manualAdjustmentKey: 'site',
            }}
            control={control}
            getValues={getValues}
            setValue={setValue}
          />
        </Flex>
      )}
      {showLabels && (
        <LabelField
          columnIndex={columnIndex}
          field={{
            fieldName: 'editableData.site.influence',
            label: 'Site Influence',
            manualAdjustmentKey: 'site',
          }}
          control={control}
          getValues={getValues}
          setValue={setValue}
        />
      )}
      <ReadOnlyField columnIndex={columnIndex} field={influenceField} colSpan={colSpan} control={control} getValues={getValues} setValue={setValue} />
      {showLabels && (
        <LabelField
          columnIndex={columnIndex}
          field={{
            fieldName: 'editableData.site.view',
            label: 'View',
            manualAdjustmentKey: 'site',
          }}
          control={control}
          getValues={getValues}
          setValue={setValue}
        />
      )}
      <ReadOnlyField columnIndex={columnIndex} field={viewField} colSpan={colSpan} control={control} getValues={getValues} setValue={setValue} />
    </>
  );
};
